import { Injectable } from "@angular/core";
import { ApiBaseService } from "./api-base.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { Observable } from "rxjs";
import { ConfigService } from "../../shared/services/config.service";
import { UserService } from "../../shared/services/user.service";
import * as moment from "moment";
import { Time } from "../models/time.model";
import { SumTimeTypeDto } from "../dtos/sum-timetype.dto";
import { MomentFormatterService } from "src/app/shared/helpers/datetime/moment-formatter.service";

@Injectable({
    providedIn: "root"
  })

export class TimesService extends ApiBaseService {
    constructor(private configService: ConfigService, private http: HttpClient, private us: UserService, private momentFormatter: MomentFormatterService) {
      super(us);
      this.httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", SessionId: this.userService.sessionId, 'APIKEY': 'ams-direct-api-project-key', }) };
      this.baseUrl = `${this.configService.config.projectUrl}/api/time`;
    }

    getByProjectWithinPeriod(id: number, fromDate: moment.Moment, toDate: moment.Moment): Observable<Time[]> {
      const request = { "ProjectId": id, "FromDate": fromDate, "ToDate": toDate };

      return this.http.post<Time[]>(`${this.baseUrl}/getbyprojectwithinperiod`, request, this.httpOptions)
        .pipe(catchError(this.handleError<any>(`Failed to get times`)));
    }

    getApprovedByProjectWithinPeriod(id: number, fromDate: moment.Moment, toDate: moment.Moment): Observable<Time[]> {
      const request = {
        "ProjectId": id,
        "FromDate": this.momentFormatter.dateOnly(fromDate),
        "ToDate": this.momentFormatter.dateOnly(toDate)
      };

      return this.http.post<Time[]>(`${this.baseUrl}/getapprovedbyprojectwithinperiod`, request, this.httpOptions)
        .pipe(catchError(this.handleError<any>(`Failed to get times`)));
    }

    getSumTimeTypeByProjectWithinPeriod(id: number, fromDate: moment.Moment, toDate: moment.Moment): Observable<SumTimeTypeDto[]> {
      const request = {
        "ProjectId": id,
        "FromDate": this.momentFormatter.dateOnly(fromDate),
        "ToDate": this.momentFormatter.dateOnly(toDate)
      };

      return this.http.post<SumTimeTypeDto[]>(`${this.baseUrl}/getSumTimeTypeByProjectWithinPeriod`, request, this.httpOptions)
        .pipe(catchError(this.handleError<any>(`Failed to get sum of time types for project within period`)));
    }

    getSumTimeTypeByProject(id: number): Observable<SumTimeTypeDto[]> {
      return this.http.get<SumTimeTypeDto[]>(`${this.baseUrl}/getSumTimeTypeByProject?projectid=${id}`, this.httpOptions)
        .pipe(catchError(this.handleError<any>(`Failed to get sum of time types for project`)));
    }

    getByProjectAndEmployeeWithinPeriod(projectId: number, employeeId: number, fromDate: moment.Moment, toDate: moment.Moment, categoryId: number, timeTypeId: number): Observable<Time[]> {
      const request = { "ProjectId": projectId, EmployeeId: employeeId, "FromDate": fromDate, "ToDate": toDate, "CategoryId": categoryId, "TimeTypeId": timeTypeId };

      return this.http.post<Time[]>(`${this.baseUrl}/getbyprojectandemployeewithinperiod`, request, this.httpOptions)
        .pipe(catchError(this.handleError<any>(`Failed to get times`)));
    }

    getProjectPortalChartTimesWithinPeriod(projectId: number, employeeId: number, fromDate: moment.Moment, toDate: moment.Moment, categoryId: number, timeTypeId: number): Observable<Time[]> {
      const request = {
        "ProjectId": projectId,
        "EmployeeId": employeeId,
        "FromDate": this.momentFormatter.dateOnly(fromDate),
        "ToDate": this.momentFormatter.dateOnly(toDate),
        "CategoryId": categoryId,
        "TimeTypeId": timeTypeId };

      return this.http.post<Time[]>(`${this.baseUrl}/getprojectportalcharttimeswithinperiod`, request, this.httpOptions)
        .pipe(catchError(this.handleError<any>(`Failed to get times for project portal chart`)));
    }
}
